export const NumberInputActionTypes = {
  clamp: 'numberInput:clamp',
  inputChange: 'numberInput:inputChange',
  increment: 'numberInput:increment',
  decrement: 'numberInput:decrement',
  decrementToMin: 'numberInput:decrementToMin',
  incrementToMax: 'numberInput:incrementToMax',
  resetInputValue: 'numberInput:resetInputValue'
};